const withBaseURL = path => `${process.env.CUSTOMER_API_BASE_URL}${path}`;
const LIST_ORDERS_API = withBaseURL('/orders');
const CREATE_ORDERS_API = withBaseURL('/orders/create');
const FIND_ORDER_BY_TRANSACTION_ID_API = withBaseURL('/orders/thank-you/{id}');
const GET_SHIPPING_OPTIONS = withBaseURL('/orders/get-shipping-options');
const GET_COUPON_DISCOUNT = withBaseURL('/orders/get-coupon-discount-data');
const CHECK_USER_EMAIL_SUBSCRIBED = withBaseURL('/coupon/check-user-email-subscribed/{email}');
const IS_WHOLESALE_ACCOUNT = withBaseURL('/customers/is-wholesale-account');

export default {
    LIST_ORDERS_API,
    CREATE_ORDERS_API,
    FIND_ORDER_BY_TRANSACTION_ID_API,
    GET_SHIPPING_OPTIONS,
    GET_COUPON_DISCOUNT,
    CHECK_USER_EMAIL_SUBSCRIBED,
    IS_WHOLESALE_ACCOUNT,
};

export {
    LIST_ORDERS_API,
    CREATE_ORDERS_API,
    FIND_ORDER_BY_TRANSACTION_ID_API,
    GET_SHIPPING_OPTIONS,
    GET_COUPON_DISCOUNT,
    CHECK_USER_EMAIL_SUBSCRIBED,
    IS_WHOLESALE_ACCOUNT,
};
